import { render, staticRenderFns } from "./FooterPrimary.vue?vue&type=template&id=20644ff6&"
import script from "./FooterPrimary.vue?vue&type=script&lang=js&"
export * from "./FooterPrimary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports